import 'Guide/entrypoint/guidepage';
import './home_page_ctas';
import './home_page_guide_categories';
import './home_page_news_heading';
import './home_page_hero';
import './partnerships_display';
import './kpi_display';
import './featured_documents';
import 'Shared/Campaigns/campaign-banner-wp';
import { WPNewsletter } from 'Shared/newsletter';
import { trackLinkInPiwikAndGA } from 'Shared/Analytics/CombinedGAPiwik';
import { querySelectorAllWithShadowed } from 'Shared/utils/shadow-wrapper';

onDomReady(() => {
   querySelectorAllWithShadowed('.newsletter-sub').forEach(newsLetterEl => {
      new WPNewsletter(newsLetterEl, 'Homepage');
   });

   querySelectorAllWithShadowed('.js-product-ad').forEach(el => {
      trackLinkInPiwikAndGA(el, {
         eventCategory: 'Featured Products - Homepage',
         eventAction: `Featured on Homepage - ${el.get('data-ga-product')}`,
      });
   });
});
